<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'App'
}
</script>

<style>
html {
  line-height: 1.15;
  -webkit-text-size-adjust: 100%;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

*, :active, :focus, :hover {
  outline: 0;
}
/* 分割线 */
.el-divider--horizontal{
  margin: 5px 0;
}
.el-table__row:hover .opera{
  display: inline-block !important;
}
.finishedCls{
  font-size: 30px;
}
.el-collapse-item__header{
  border:none !important;
  background: transparent;
}
.el-collapse,.el-collapse-item__wrap{
  border:none !important;
  background: transparent;
}
.el-collapse-item__content .el-collapse-item__content{
  padding-bottom:0px;
}

</style>



// WEBPACK FOOTER //
// src/App.vue